import { render, staticRenderFns } from "./ClientLocation.vue?vue&type=template&id=7c63480d&"
import script from "./ClientLocation.vue?vue&type=script&lang=js&"
export * from "./ClientLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports